import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Carousel,
  Accordion,
  Button,
  Form,
} from "react-bootstrap";
import "./Home.css";

import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

import { useParams, Link } from "react-router-dom";
import { Card } from "react-bootstrap";
import "./CourseCategory.css";

// Replace these with your real images in /src/assets
// import banner1 from "../assets/abg.jpg";
// import banner2 from "../assets/abg.jpg";
import banner3 from "../assets/abg.jpg";
import reachImg1 from "../assets/abg.jpg";
// import indiaMap from "../assets/abg.jpg";
import partner1 from "../assets/abg.jpg";
import partner2 from "../assets/abg.jpg";
import partner3 from "../assets/abg.jpg";
import feature1 from "../assets/abg.jpg";
import feature2 from "../assets/abg.jpg";
import feature3 from "../assets/abg.jpg";
import feature4 from "../assets/abg.jpg";
import bnrimg from "../assets/abg.jpg";
import map from "../assets/india_map.jpg";

import bnr1 from "../assets/bnr1.jpg";
import bnr2 from "../assets/bnr2.jpg";
import bnr3 from "../assets/bnr3.jpg";
import mca from "../assets/MCA.png";
import placementsImg from "../assets/placements.jpg";
import liveclassesImg from "../assets/liveclasses.png";
import industryprojectsImg from "../assets/industryprojects.jpg";
import careerImg from "../assets/careersupport.jpg";
import aimlBnrImg from "../assets/aimlBnr1.jpg";
import mainhomebannerImg from "../assets/mainhomebanner.png";
import banner3Img from "../assets/bannerr3.jpg";
import certificateImg from "../assets/certifications.png";
import B1 from "../assets/B1.png";
import B2 from "../assets/B2.png";
import B3 from "../assets/B3.jpg";
import B11 from "../assets/B11.jpg";
import CI1 from "../assets/CI1.jpeg";
import CI2 from "../assets/CI2.jpeg";
import CI3 from "../assets/CI3.jpeg";
import InternshipIcon from "../assets/Internship_icon.jpeg";
import javaImg from "../assets/java.jpeg";
import mernImg from "../assets/Mern.png";
import uiuxImg from "../assets/uiux.jpg";
import datascienceImg from "../assets/datascience.jpg";
import aimlImg from "../assets/aiml.jpg";
import cloudImg from "../assets/cloud.jpeg";
import dsaImg from "../assets/dsa.jpg";
import appImg from "../assets/appdevelopment.png";
import cybersecurityImg from "../assets/cs.png";
import digitalmarketingImg from "../assets/digitalmarketing.jpeg";
import dataanalyticsImg from "../assets/dataanalytics.jpeg";
import autocadImg from "../assets/Autocad.jpg";

import bnrbg1 from "../assets/bnrbg1.png";
import bnrbg2 from "../assets/bnrbg2.png";
import bnrbg3 from "../assets/bnrbg3.png";
import bnrwbnr from "../assets/bnrwbnr.png";
import bnrabt from "../assets/bnrabt.png";
import webinarImg1 from "../assets/webinarImg1.png";
import bnrcarouselimg2 from "../assets/bnrcarouselimg2.png";
import hmpgimg1 from "../assets/hmpg1.png";
import hmpgimg2 from "../assets/hmpg2.png";
import hmpgimg22 from "../assets/hmpg22.png";
import hmpgitimg from "../assets/hmpgit.png";
import hmpgmgmtimg from "../assets/hmpgmgmt.png";
import collaborationImg from "../assets/collaboration.jpeg";

// import trainer1 from "../assets/trainer1.jpg";
// import trainer2 from "../assets/trainer2.jpg";
// import trainer3 from "../assets/trainer3.jpg";
// import trainer4 from "../assets/trainer4.jpg";
// import trainer5 from "../assets/trainer5.jpg";

import { useNavigate } from "react-router-dom";

function Home() {
  const [contact, setContact] = useState({
    name: "",
    email: "",
    number: "",
    message: "",
  });

  const navigate = useNavigate();

  const handleContactChange = (e) => {
    setContact({ ...contact, [e.target.name]: e.target.value });
  };

  const handleContactSubmit = (e) => {
    e.preventDefault();
    alert(
      `Thanks ${
        contact.name || "there"
      }! We've received your message. We'll contact you soon.`
    );
    setContact({ name: "", email: "", number: "", message: "" });
  };

  const statsData = [
    { value: "25+", label: "Corporate Experienced Trainers" },
    { value: "120+", label: "Learners" },
    { value: "30+", label: "HR Connections Across India" },
    { value: "8+", label: "Live Projects" },
    { value: "40+", label: "Internships provided (Any Degree)" },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleStatsScroll = (direction) => {
    const slider = document.getElementById("statsSlider");
    if (!slider) return;

    const card = slider.querySelector(".stats-card");
    const cardWidth = card.offsetWidth + 20;

    if (direction === "right") {
      if (
        slider.scrollLeft + slider.clientWidth >=
        slider.scrollWidth - cardWidth
      ) {
        slider.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        slider.scrollBy({ left: cardWidth, behavior: "smooth" });
      }
    }

    if (direction === "left") {
      if (slider.scrollLeft <= 0) {
        slider.scrollTo({
          left: slider.scrollWidth,
          behavior: "smooth",
        });
      } else {
        slider.scrollBy({ left: -cardWidth, behavior: "smooth" });
      }
    }
  };

  return (
    <div className="home-section">
      <div className="spacer" />

      {/* ---------- Banner Carousel ---------- */}
      {/* <section className="home-section"> */}
      {/* ---------- Banner Section (New Carousel) ---------- */}
      <section className="home-banner">
        <Carousel controls={true} indicators={false} fade interval={20000}>


           <Carousel.Item>
            <div className="banner-slide">
              <img
                className="d-block w-100 banner-image"
                src={hmpgimg1}
                alt="Empowering Future"
              />
            </div>
            <div className="banner-bottom-caption">
              <h2>Empowering Careers in Technology</h2>
              <p>
                Join thousands of learners shaping their future with DevSkillz.
              </p>
              <button
                className="banner-btn"
                onClick={() => navigate("/courses/technical")}
              >
                Explore Courses
              </button>
            </div>
          </Carousel.Item>
          
           <Carousel.Item>
            <div className="banner-slide">
              <img
                className="d-block w-100 banner-image"
                src={hmpgimg22}
                alt="Empowering Future"
              />
            </div>
            <div className="banner-bottom-caption">
              <h2>Empowering Careers in Technology</h2>
              <p>
                Join thousands of learners shaping their future with DevSkillz.
              </p>
              <button
                className="banner-btn"
                onClick={() => navigate("/courses/technical")}
              >
                Explore Courses
              </button>
            </div>
          </Carousel.Item>

          <Carousel.Item>
            <div className="banner-slide">
              <img
                className="d-block w-100 banner-image"
                src={webinarImg1}
                alt="Empowering Future"
              />
            </div>

            <div className="banner-bottom-caption">
              <h2>Empowering Careers in Technology</h2>
              <p>
                Join thousands of learners shaping their future with DevSkillz.
              </p>

              {/* ✅ TWO BUTTONS CENTERED */}
              <div className="banner-btn-group">
                {/* ✅ BOOK A SLOT – PAYMENT LINK */}
                <button
                  className="banner-btn primary"
                  onClick={() =>
                    window.open(
                      "https://rzp.io/rzp/t8Z2lbA",
                      "_blank",
                      "noopener,noreferrer"
                    )
                  }
                >
                  Book a Slot
                </button>

                {/* ✅ TALK TO US – ZOHO FORM */}
                <button
                  className="banner-btn secondary"
                  onClick={() =>
                    window.open(
                      "https://forms.zohopublic.in/teamhrdevs1/form/CourseRegistrationForm/formperma/oiKX6sX7_NH-6Kk1EkojLP83Zt4KS3RVT0zlgVEqTNs",
                      "_blank",
                      "noopener,noreferrer"
                    )
                  }
                >
                  Know More
                </button>
              </div>
            </div>
          </Carousel.Item>

          <Carousel.Item>
            <div className="banner-slide">
              <img
                className="d-block w-100 banner-image"
                src={hmpgitimg}
                alt="Empowering Future"
              />
            </div>
            <div className="banner-bottom-caption">
              <h2>Empowering Careers in Technology</h2>
              <p>
                Join thousands of learners shaping their future with DevSkillz.
              </p>
              <button
                className="banner-btn"
                onClick={() => navigate("/courses/technical")}
              >
                Explore Courses
              </button>
            </div>
          </Carousel.Item>

          {/* <Carousel.Item>
            <div className="banner-slide">
              <img
                className="d-block w-100 banner-image"
                src={bnrbg1}
                alt="Empowering Future"
              />
            </div>
            <div className="banner-bottom-caption">
              <h2>Empowering Careers in Technology</h2>
              <p>
                Join thousands of learners shaping their future with DevSkillz.
              </p>
              <button
                className="banner-btn"
                onClick={() => navigate("/courses/technical")}
              >
                Explore Courses
              </button>
            </div>
          </Carousel.Item> */}

          <Carousel.Item>
            <div className="banner-slide">
              <img
                className="d-block w-100 banner-image"
                src={hmpgmgmtimg}
                alt="Industry Experts"
              />
            </div>
            <div className="banner-bottom-caption">
              <h2>Build your career in the Management</h2>
              <p>
                Join the opportunity to build your management career with our
                courses.
              </p>
              <button
                className="banner-btn"
                onClick={() => navigate("/courses/management")}
              >
                Explore Courses
              </button>
            </div>
          </Carousel.Item>

          {/* <Carousel.Item>
      <div className="banner-slide">
        <img className="d-block w-100 banner-image" src={bnrbg3} alt="Nationwide Reach" />
      </div>
      <div className="banner-bottom-caption caption-white">
        <h2>Get Interview ready</h2>
        <p>Get placement ready with our training and placement program.</p>
        <button className="banner-btn" onClick={() => navigate("/courses/tp")}>
          Explore Courses
        </button>
      </div>
    </Carousel.Item> */}
        </Carousel>
      </section>

      <section className="our-courses py-5">
        <Container>
          <h2 className="text-center mb-4" style={{ color: "white" }}>
            Our Courses
          </h2>

          <Row>
            <Col md={4} className="mb-4">
              <Link to="/courses/technical" className="text-decoration-none">
                <Card className="course-card shadow-sm border-0">
                  <Card.Img variant="top" src={CI1} />
                  <Card.Body>
                    <Card.Title className="text-center">
                      Software Courses
                    </Card.Title>
                  </Card.Body>
                </Card>
              </Link>
            </Col>

            <Col md={4} className="mb-4">
              <Link to="/courses/management" className="text-decoration-none">
                <Card className="course-card shadow-sm border-0">
                  <Card.Img variant="top" src={CI2} />
                  <Card.Body>
                    <Card.Title className="text-center">
                      Management Courses
                    </Card.Title>
                  </Card.Body>
                </Card>
              </Link>
            </Col>

            <Col md={4} className="mb-4">
              <Link to="/courses/tp" className="text-decoration-none">
                <Card className="course-card shadow-sm border-0">
                  <Card.Img variant="top" src={CI3} />
                  <Card.Body>
                    <Card.Title className="text-center">
                      Training & Placement
                    </Card.Title>
                  </Card.Body>
                </Card>
              </Link>
            </Col>
          </Row>
        </Container>
      </section>

      {/* ---------- Stats Slider Section ---------- */}
      <Row className="justify-content-center mt-5">
        <Col lg={12}>
          <div className="glass-panel stats-panel text-center">
            <h3 className="section-title mb-4">Our Impact & Achievements</h3>

            <div className="stats-slider-wrapper">
              {/* LEFT ARROW (MOBILE ONLY) */}
              <button
                className="slider-arrow mobile-only"
                onClick={() =>
                  setCurrentIndex(
                    currentIndex === 0 ? statsData.length - 1 : currentIndex - 1
                  )
                }
              >
                ‹
              </button>

              {/* SLIDER */}
              <div className="stats-slider">
                <div
                  className="stats-track"
                  style={{
                    transform: `translateX(-${currentIndex * 100}%)`,
                  }}
                >
                  {statsData.map((item, index) => (
                    <div className="stats-card" key={index}>
                      <h2 className="stats-number">{item.value}</h2>
                      <p className="stats-label">{item.label}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* RIGHT ARROW (MOBILE ONLY) */}
              <button
                className="slider-arrow mobile-only"
                onClick={() =>
                  setCurrentIndex(
                    currentIndex === statsData.length - 1 ? 0 : currentIndex + 1
                  )
                }
              >
                ›
              </button>
            </div>
          </div>
        </Col>
      </Row>

    <section className="collaboration-section py-5">
  <Row className="justify-content-center">
    <Col lg={10}>
      <div className="glass-panel badge-panel text-center">
        <h3 className="section-title collaboration-title mb-4">
          In Collaboration With
        </h3>

        <div className="partners-logos d-flex justify-content-center flex-wrap">
          <img src={collaborationImg} alt="MCA Logo" className="partner-logo collaboration-logo" />
        </div>
      </div>
    </Col>
  </Row>
</section>



      {/* ---------- Full-page About Us ---------- */}
      <section className="fullpage-about">
        <div className="about-content">
          <h1>About DevSkillz</h1>
          <p>
            At DevSkillz, our mission is to bridge the gap between college
            education and the professional world. We empower students with the
            latest in-demand technologies, hands-on experience, and
            industry-relevant skills to prepare them for their dream careers.
          </p>
          <p>
            Our approach focuses on practical learning through real-world
            projects, expert mentorship, and guidance that ensures students gain
            confidence and expertise in their chosen fields. We strive to create
            a learning environment that equips learners not just with technical
            knowledge, but also with problem-solving abilities, professional
            etiquette, and industry-ready skills.
          </p>
          <p>
            From building portfolios with real projects to providing
            career-oriented guidance, DevSkillz is committed to turning
            aspirations into achievements. Join us to enhance your skills,
            expand your opportunities, and step confidently into the
            professional world.
          </p>
        </div>
      </section>

      {/* ---------- Video + Why Us ---------- */}
      <Container className="pt-5 pb-5 video-why-section">
        <Row className="align-items-center">
          <Col lg={6} className="mb-4">
            <div className="glass-panel video-panel">
              <div className="video-wrapper">
                <iframe
                  title="intro-video"
                  src="https://www.youtube.com/embed/WL33gf_fZ_M"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>
          </Col>
          <Col lg={6}>
            <div className="glass-panel why-panel">
              <h3 style={{ color: "white" }}>Why Choose Us?</h3>
              <ul className="why-list">
                <li>
                  <strong>Expert Mentors:</strong> Real-world experience &
                  active industry trainers.
                </li>
                <li>
                  <strong>Project-based Learning:</strong> Build industry-grade
                  projects for your portfolio.
                </li>
                <li>
                  <strong>Placement Support:</strong> Interview prep, resume
                  reviews & partner hiring drives.
                </li>
                <li>
                  <strong>Flexible Schedules:</strong> Weekday, weekend & online
                  batches available.
                </li>
                <li>
                  <strong>Lifetime Community Access:</strong> Network with
                  alumni & mentors.
                </li>
                <li>
                  <strong>Paid Internship</strong>Guaranteed paid internship
                  with 100% stipend provided based on performance.
                </li>
              </ul>
              {/* <div className="small-stats">
                <div><span>10k+</span><small>Students Trained</small></div>
                <div><span>500+</span><small>Hiring Partners</small></div>
                <div><span>95%</span><small>Placement Rate*</small></div>
              </div> */}
            </div>
          </Col>
        </Row>
      </Container>

      {/* ---------- Our HR Connections Across India ---------- */}
      <section className="hr-connections-section">
        <Container>
          <Row className="align-items-center">
            {/* Left Text Section */}
            <Col md={6} className="text-section">
              <div className="content-box">
                <h2>Our HR Connections Across India</h2>
                <p>
                  We have a strong network of HR connections across India,
                  working with major organizations in key technology and
                  business hubs. Our collaborations span across cities like{" "}
                  <strong>Delhi NCR</strong>,<strong> Mumbai</strong>,{" "}
                  <strong>Pune</strong>, <strong>Hyderabad</strong>,
                  <strong> Bengaluru</strong>, <strong>Chennai</strong>,{" "}
                  <strong>Kolkata</strong>,<strong> Bhubaneswar</strong> and
                  several other major IT cities — ensuring career opportunities
                  for every aspiring professional.
                </p>
              </div>
            </Col>

            {/* Right Map Section */}
            <Col md={6} className="map-section text-center">
              <div className="map-box">
                <img
                  src={map}
                  alt="India map showing HR connections"
                  className="india-map"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* ---------- Recognition & Testimonials ---------- */}
      <section className="recognition-section">
        <Container className="pt-5 pb-5">
          {/* Top Row - Recognitions */}
          <Row className="justify-content-center mb-5">
            <Col lg={10}>
              <div className="glass-panel badge-panel text-center">
                <h3 className="section-title">We Are Approved By</h3>
                <div className="partners-logos justify-content-center flex-wrap">
                  <img src={mca} alt="MCA Logo" className="partner-logo" />
                </div>
                {/* <p className="muted">
            Our excellence in training and placement assistance is acknowledged by 
            leading industry bodies and educational partners.
          </p> */}
              </div>
            </Col>
          </Row>

          {/* Testimonials Carousel */}
          <Row className="justify-content-center">
            <Col lg={12}>
              <div className="glass-panel testimonial-carousel-panel text-center">
                <h3 className="section-title mb-4">
                  What experts say about our courses
                </h3>

                <Carousel
                  indicators={false}
                  controls={true}
                  interval={5000}
                  wrap={true}
                  className="testimonial-card-carousel"
                >
                  {/* SLIDE 1 */}
                  <Carousel.Item>
                    <div className="testimonial-card-wrapper">
                      <div className="testimonial-card">
                        <p>
                          “The mentors at DevSkillz helped me turn theory into
                          practice through real-world projects. I got placed
                          within 2 months!”
                        </p>
                        <footer>— Ananya, Full Stack Developer</footer>
                      </div>

                      <div className="testimonial-card">
                        <p>
                          “Great environment and support. The live sessions
                          really built my confidence.”
                        </p>
                        <footer>— Raj, Data Analyst</footer>
                      </div>
                    </div>
                  </Carousel.Item>

                  {/* SLIDE 2 */}
                  <Carousel.Item>
                    <div className="testimonial-card-wrapper">
                      <div className="testimonial-card">
                        <p>
                          “Hands-on projects and mock interviews prepared me
                          well for real company challenges.”
                        </p>
                        <footer>— Priya, QA Engineer</footer>
                      </div>

                      <div className="testimonial-card">
                        <p>
                          “Personalized mentorship and 24/7 doubt support — a
                          true career accelerator.”
                        </p>
                        <footer>— Arjun, Frontend Developer</footer>
                      </div>
                    </div>
                  </Carousel.Item>
                </Carousel>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* ---------- Features ---------- */}
      <Container className="pt-4 pb-5 features-section">
        <h3 className="section-title">What We Provide</h3>

        {/* Use 6 equal columns (for balanced layout) */}
        <Row className="g-4 justify-content-center">
          <Col xs={12} sm={6} md={4} lg={2}>
            <div className="feature-card glass-panel">
              <img
                src={liveclassesImg}
                alt="live classes"
                className="feature-icon"
              />
              <h6>Live Classes</h6>
              <p>Interactive instructor-led sessions with recorded backups.</p>
            </div>
          </Col>

          <Col xs={12} sm={6} md={4} lg={2}>
            <div className="feature-card glass-panel">
              <img
                src={industryprojectsImg}
                alt="projects"
                className="feature-icon"
              />
              <h6>Industry Projects</h6>
              <p>Work on full-scale, real-world projects for your portfolio.</p>
            </div>
          </Col>

          <Col xs={12} sm={6} md={4} lg={2}>
            <div className="feature-card glass-panel">
              <img
                src={certificateImg}
                alt="certification"
                className="feature-icon"
              />
              <h6>Course Certification</h6>
              <p>Get certified for top courses from industry experts.</p>
            </div>
          </Col>

          <Col xs={12} sm={6} md={4} lg={2}>
            <div className="feature-card glass-panel">
              <img
                src={InternshipIcon}
                alt="certification"
                className="feature-icon"
              />
              <h6>Internship Opportunity</h6>
              <p>
                Guaranteed internship provided with 100% stipend based on
                performance.
              </p>
            </div>
          </Col>

          <Col xs={12} sm={6} md={4} lg={2}>
            <div className="feature-card glass-panel">
              <img
                src={placementsImg}
                alt="placement"
                className="feature-icon"
              />
              <h6>Placement Assistance</h6>
              <p>Resume reviews, mock interviews, and hiring drives.</p>
            </div>
          </Col>

          <Col xs={12} sm={6} md={4} lg={2}>
            <div className="feature-card glass-panel">
              <img
                src={careerImg}
                alt="career support"
                className="feature-icon"
              />
              <h6>Career Support</h6>
              <p>Mentorship, counselling, and alumni networking.</p>
            </div>
          </Col>
        </Row>
      </Container>

      {/* ---------- FAQs ---------- */}
      <Container className="pt-4 pb-5 faq-section">
        <h3 className="section-title">Frequently Asked Questions</h3>
        <Accordion defaultActiveKey="0" className="glass-panel faq-accordion">
          <Accordion.Item eventKey>
            <Accordion.Header>
              What is the duration of the courses?
            </Accordion.Header>
            <Accordion.Body>
              Course durations vary by program — from 8 weeks for short courses
              to 6+ months for full programs. Flexible and part-time batches
              available.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              Do you offer placement assistance?
            </Accordion.Header>
            <Accordion.Body>
              Yes — we provide placement assistance including resume reviews,
              mock interviews and introductions to hiring partners.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2">
            <Accordion.Header>
              Are there weekend or online batches?
            </Accordion.Header>
            <Accordion.Body>
              Yes — we run weekday, weekend and fully online batches to suit
              working professionals and students.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3">
            <Accordion.Header>
              What is included in the curriculum?
            </Accordion.Header>
            <Accordion.Body>
              The curriculum includes fundamentals, advanced modules, hands-on
              projects, and soft-skill interview preparation.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="4">
            <Accordion.Header>Do you provide scholarships?</Accordion.Header>
            <Accordion.Body>
              We offer selective scholarships and early-bird discounts. Contact
              us for current offers.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="5">
            <Accordion.Header>How do I enroll?</Accordion.Header>
            <Accordion.Body>
              Click the "Explore Courses" button on the banner or fill the
              contact form below — our counsellor will reach out.
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Container>

      {/* ---------- Contact Form ---------- */}
      <Container className="pt-4 pb-5 contact-section">
        <Row className="justify-content-center">
          <Col lg={8}>
            <div className="glass-panel contact-panel">
              <h3>Wanna connect with us?</h3>
              <Form onSubmit={handleContactSubmit}>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Control
                        required
                        name="name"
                        value={contact.name}
                        onChange={handleContactChange}
                        placeholder="Your name"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Control
                        required
                        type="email"
                        name="email"
                        value={contact.email}
                        onChange={handleContactChange}
                        placeholder="Email"
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Control
                        required
                        name="number"
                        value={contact.number}
                        onChange={handleContactChange}
                        placeholder="Phone number"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Select aria-label="inquiry-type">
                        <option>I'm interested in</option>
                        <option value="course">Course enquiry</option>
                        <option value="partnership">Internship</option>
                        <option value="other">Other</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
                <Form.Group className="mb-3">
                  <Form.Control
                    as="textarea"
                    rows={4}
                    name="message"
                    value={contact.message}
                    onChange={handleContactChange}
                    placeholder="Message"
                  />
                </Form.Group>
                <div className="d-flex justify-content-end">
                  <Button type="submit" className="cta-btn">
                    Send Message
                  </Button>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>

      <div style={{ height: 60 }} />
    </div>
  );
}

export default Home;
